import React from "react";
import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function OrderAddress() {
  return (
    <div className="my-5">
      <Card>
        <Card.Body>
          <Card.Subtitle className="mb-2">Directions</Card.Subtitle>
          <Card.Text>
            <div>
              <div className="order-address-directions">
                <span className="order-address-directions-dot"></span>
                <span className="ms-3 me-1 order-address-directions">
                  Enter Address and hit{" "}
                </span>
                <Button variant="success">Search</Button>{" "}
              </div>
              <div className="order-address-directions">
                <span className="order-address-directions-dot"></span>
                <span className="ms-3 me-1 order-address-directions">
                  Place pin on correct property if known and click
                </span>
                <Button variant="warning">That's it</Button>
              </div>
              <div className="order-address-directions">
                <span className="order-address-directions-dot"></span>
                <span className="ms-3 me-1 order-address-directions">
                  If you are unsure of the property, it's okay. Just click{" "}
                </span>
                <Button variant="warning">I'm not sure</Button>
              </div>
              <div className="order-address-directions">
                <span className="order-address-directions-dot"></span>
                <span className="ms-3 me-1 order-address-directions">
                  Click
                </span>
                <Button variant="primary">next</Button>
                <span className="ms-1 order-address-directions">
                  to continue the order OR enter another address to order
                  multiple reports
                </span>
              </div>
            </div>
          </Card.Text>
        </Card.Body>
      </Card>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'end', height: '100%' }} className="pt-5">
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Link to="/order/instructions">
           <Button variant="primary">Next</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
